export const paymentAccounts = {
  // Stripe i Wompi to DWIE integracje, a nie dwie opcje jednej: każda
  // ma swój ekran i swój nagłówek. `tagline` to linia, która osadza
  // (gdzie rozlicza i jakimi metodami).
  header: {
    stripe: {
      title: "Płatności przez Stripe",
      tagline: "Karty międzynarodowe · Hiszpania i większość krajów",
      description:
        "Podłącz jedno lub kilka kont Stripe i zdecyduj, przez które rozlicza się każde ogłoszenie.",
    },
    wompi: {
      title: "Płatności przez Wompi",
      tagline: "Kolumbia · PSE, Nequi i karty kolumbijskie",
      description:
        "Podłącz jedno lub kilka kont Wompi i zdecyduj, przez które rozlicza się każde ogłoszenie.",
    },
    bold: {
      title: "Płatności przez Bold",
      tagline: "Kolumbia i Peru · PSE, Nequi, Bancolombia i karty",
      description:
        "Podłącz jedno lub kilka kont Bold i wybierz, którym rozlicza się każde ogłoszenie.",
    },
    redsys: {
      title: "Płatności przez Redsys",
      tagline: "Hiszpania · Wirtualny terminal Twojego banku",
      description:
        "Połącz wirtualny terminal swojego banku i wybierz, którym kontem pobiera płatności każde ogłoszenie. Pieniądze trafiają prosto na Twoje konto bankowe.",
      card: "Wirtualny terminal Twojego banku (Hiszpania)",
    },
  },

  // Wompi tam, gdzie nie ma zastosowania. O bramce decyduje kraj
  // OGŁOSZENIA, a nie właściciela: dlatego mowa o obiektach, a nie
  // o Tobie.
  notAvailable: {
    title: "Wompi jest dla obiektów w Kolumbii",
    text: "Wompi rozlicza w peso kolumbijskich przez PSE, Nequi i karty kolumbijskie. Nie masz tam żadnego obiektu, więc nie ma tu czego podłączać.",
    hint: "Jeśli dodasz obiekt w Kolumbii, ten ekran otworzy się sam.",
    button: "Przejdź do {provider}",
  },

  session: {
    title: "Twoja sesja wygasła",
    text: "Nic nie przepadło: Twoje konta rozliczeniowe są nadal podłączone. Zaloguj się ponownie, aby je zobaczyć.",
    button: "Zaloguj się ponownie",
  },

  status: {
    ready: "Gotowe",
    incomplete: "Niekompletne",
    unverified: "Niezweryfikowane",
  },

  environment: {
    test: "Testy",
  },

  accounts: {
    card: {
      title: "Twoje konta {provider}",
      subtitle: "Podłączaj nowe konta i sprawdzaj, czy są gotowe do przyjmowania płatności.",
    },
    searchPlaceholder: "Szukaj konta po nazwie…",
    newButton: "Podłącz konto {provider}",
    noName: "Bez nazwy",
    fallbackName: "Konto nr {id}",
    defaultBadge: "Główne",
    listingsCount: "{count} ogłoszenie | {count} ogłoszenia | {count} ogłoszeń",
    empty: {
      none: "Nie podłączono jeszcze żadnego konta {provider}.",
      noMatch: "Żadne konto nie pasuje do wyszukiwania.",
    },
    actions: {
      edit: "Edytuj",
      setDefault: "Ustaw jako główne",
      isDefault: "To już konto główne",
      resume: "Dokończ rejestrację",
      verify: "Zweryfikuj",
      disconnect: "Odłącz",
    },
  },

  assign: {
    card: {
      title: "Podział na ogłoszenia",
      subtitle: "Wybierz, które ogłoszenia obsługuje każde konto {provider}.",
    },
    searchPlaceholder: "Szukaj ogłoszenia po nazwie…",
    filter: {
      all: "Wszystkie",
      unassigned: "Bez przypisania",
      notReady: "Bez płatności",
      other: "Rozlicza przez {provider}",
    },
    // Bez przypisanego konta. Gdy wiadomo, które jest główne, podajemy jego nazwę:
    // to właśnie gospodarz chce wiedzieć – przez które konto rozlicza się ogłoszenie.
    autoOption: "Konto główne",
    autoOptionNamed: "Konto główne · {name}",
    autoOptionOther: "Konto główne {provider} · {name}",
    otherProvider: "Rozlicza przez {provider} · {name}",
    otherProviderLink: "Zarządzaj w {provider}",
    notReadyRow: "Nie przyjmie płatności",
    notReadyRowTip: "Konto przypisane do tego ogłoszenia nie jest jeszcze gotowe, więc gość nie zapłaci.",
    notReadyAutoRow: "Konto główne nie przyjmie płatności",
    notReadyAutoRowTip: "To ogłoszenie korzysta z konta głównego, które nie jest jeszcze gotowe. Dokończ je albo przypisz ogłoszeniu inne konto.",
    notReadyBanner: "{count} ogłoszenie nie przyjmie teraz płatności: jego konto nie jest jeszcze gotowe. Goście nie zapłacą, dopóki nie dokończysz tego konta. | {count} ogłoszenia nie przyjmą teraz płatności: ich konto nie jest jeszcze gotowe. Goście nie zapłacą, dopóki nie dokończysz tego konta. | {count} ogłoszeń nie przyjmie teraz płatności: ich konto nie jest jeszcze gotowe. Goście nie zapłacą, dopóki nie dokończysz tego konta.",
    notReadyBannerLink: "Pokaż te ogłoszenia",
    defaultSuffix: " (główne)",
    empty: {
      none: "Nie masz jeszcze ogłoszeń.",
      noMatch: "Żadne ogłoszenie nie pasuje do filtra.",
    },
    count: "Widocznych {shown} z {total} ogłoszeń",
  },

  drawer: {
    newTitle: "Podłącz konto {provider}",
    editTitle: "Edytuj konto {provider}",
    subtitle: "Nadaj mu nazwę i wybierz, które ogłoszenia obsługuje.",
    closeAria: "Zamknij panel",

    stripe: {
      title: "Rejestracja w Stripe",
      subtitle: "Stripe poprosi o Twoje dane i wróci z Tobą tutaj.",
      explain:
        "Przeniesiemy Cię do Stripe, żeby założyć konto pod tą nazwą i zweryfikować dane. Po powrocie wybierzesz ogłoszenia; jeśli przerwiesz rejestrację, konto poczeka tu na dokończenie.",
      button: "Przejdź do Stripe",
      connecting: "Otwieram Stripe…",
      resumeTitle: "Niedokończona rejestracja w Stripe",
      resumeSubtitle: "Brakuje weryfikacji po stronie Stripe.",
      resumeExplain: "To konto powstało, ale nie dokończyło rejestracji w Stripe, więc nie przyjmie jeszcze płatności. Wróć do miejsca, w którym skończyłeś.",
      resumeButton: "Dokończ rejestrację",
    },

    data: {
      title: "Dane konta",
      subtitle: "Nazwa jest tylko dla Ciebie: pomaga odróżnić konta.",
      label: "Nazwa konta",
      labelPlaceholder: "Na przykład: Apartamenty przy plaży",
      labelHint: "Gość nigdy jej nie widzi.",
      publicKey: "Klucz publiczny",
      privateKey: "Klucz prywatny",
      privateKeyKept: "Zostaje ten, który już był",
      privateKeyHint: "Zostaw puste, żeby zachować zapisany klucz.",
      stripeId: "Identyfikator Stripe",
    },

    listings: {
      title: "Obsługiwane ogłoszenia",
      subtitle: "Zaznaczone przestaną rozliczać się przez poprzednie konto.",
      label: "Ogłoszenia tego konta",
      selectedCount: "Zaznaczono {selected} z {total}",
      searchPlaceholder: "Szukaj ogłoszenia…",
      selectAll: "Zaznacz wszystkie",
      clear: "Wyczyść",
      takenBy: "teraz w {name}",
      noResults: "Żadne ogłoszenie nie pasuje do wyszukiwania.",
      hint: "Ogłoszenia niezaznaczone na żadnym koncie rozliczają się przez konto główne.",
      otherHidden: "Nie ma tu {count} ogłoszenia rozliczanego przez {provider}: zarządzasz nim na jego ekranie. | Nie ma tu {count} ogłoszeń rozliczanych przez {provider}: zarządzasz nimi na ich ekranie. | Nie ma tu {count} ogłoszeń rozliczanych przez {provider}: zarządzasz nimi na ich ekranie.",
    },

    footer: {
      isDefault: "To już konto główne",
      setDefault: "Ustaw jako główne",
      disconnect: "Odłącz",
      cancel: "Anuluj",
      save: "Zapisz",
      saving: "Zapisuję…",
    },
  },

  disconnect: {
    title: "Odłącz konto",
    subtitle: "Przestaniesz przez nie przyjmować płatności.",
    confirm:
      "Zaraz odłączysz „{name}”. Już rozliczone rezerwacje zostają bez zmian, ale to konto nie przyjmie nowych płatności.",
    blocked:
      "„{name}” obsługuje jeszcze {count} ogłoszenie. Przed odłączeniem trzeba przenieść je na inne konto. | „{name}” obsługuje jeszcze {count} ogłoszenia. Przed odłączeniem trzeba przenieść je na inne konto. | „{name}” obsługuje jeszcze {count} ogłoszeń. Przed odłączeniem trzeba przenieść je na inne konto.",
    moveLabel: "Przenieś te ogłoszenia na",
    moveHint: "Przeniesiemy je na wybrane konto, a potem odłączymy to.",
    cancel: "Anuluj",
    accept: "Odłącz",
    seeListings: "Pokaż te ogłoszenia",
    moveAndDisconnect: "Przenieś i odłącz",
  },

  loading: {
    accounts: "Wczytuję Twoje konta rozliczeniowe…",
  },

  msg: {
    loadError: "Nie udało się wczytać kont rozliczeniowych.",
    labelRequired: "Nadaj kontu nazwę.",
    publicKeyRequired: "Brakuje klucza publicznego Wompi.",
    privateKeyRequired: "Brakuje klucza prywatnego Wompi.",
    saved: "Konto zapisane.",
    saveError: "Nie udało się zapisać konta.",
    stripeNoUrl: "Stripe nie zwrócił linku do rejestracji. Spróbuj jeszcze raz.",
    stripeConnectError: "Nie udało się otworzyć rejestracji w Stripe.",
    verified: "Konto jest zweryfikowane.",
    verifiedWithName: "Konto zweryfikowane: {name}.",
    notVerified: "Konto nie jest jeszcze zweryfikowane. Sprawdź klucze.",
    verifyError: "Nie udało się zweryfikować konta.",
    defaultUpdated: "To teraz konto główne.",
    defaultError: "Nie udało się zmienić konta głównego.",
    disconnected: "Konto odłączone.",
    disconnectError: "Nie udało się odłączyć konta.",
    movedAndDisconnected: "Ogłoszenia przeniesione, konto odłączone.",
    savedNotReady: "Uwaga: to konto nie przyjmie jeszcze płatności, a ma przypisane {count} ogłoszenie. Dokończ je, bo inaczej zostanie bez płatności. | Uwaga: to konto nie przyjmie jeszcze płatności, a ma przypisane {count} ogłoszenia. Dokończ je, bo inaczej zostaną bez płatności. | Uwaga: to konto nie przyjmie jeszcze płatności, a ma przypisanych {count} ogłoszeń. Dokończ je, bo inaczej zostaną bez płatności.",
    assignError: "Nie udało się zmienić konta tego ogłoszenia.",
  },

  integrations: {
    connectedAccounts: "Podłączone konta: {count} | Podłączone konta: {count} | Podłączone konta: {count}",
    notApplicable: "Dla obiektów w Kolumbii",
    notApplicableSpain: "Dla obiektów w Hiszpanii",
  },

  // Redsys: los tres datos del TPV que da el banco, y el entorno.
  redsys: {
    environment: "Środowisko",
    environmentHint: "Bank daje Ci jedne dane do testów, a inne do prawdziwych płatności. Wybierz, do których należą te, które wpisujesz.",
    env: {
      test: "Testowe",
      prod: "Produkcyjne",
    },
    merchantCode: "Numer akceptanta (FUC)",
    merchantCodeHint: "Znajdziesz go w umowie terminala lub w module administracyjnym Redsys. Same cyfry, zwykle dziewięć.",
    terminal: "Terminal",
    terminalHint: "Prawie zawsze 1. Jeśli bank dał Ci kilka, ten od terminala wirtualnego.",
    secretKey: "Klucz podpisu (SHA-256)",
    secretKeyHint: "W module administracyjnym Redsys → Dane akceptanta → „Pokaż klucz”. Sprawdzamy go w Redsys przy zapisie, bez pobierania opłat.",
    onlyEuro: "Tylko euro · rozlicza w {currency}",
    onlyEuroTip: "Redsys pobiera płatności tylko w euro. Przypisz ten obiekt do innego konta płatności.",
    msg: {
      merchantCode: "Numer akceptanta to same cyfry (zwykle dziewięć).",
      terminal: "Terminal to liczba od jednej do trzech cyfr (prawie zawsze 1).",
      secretKey: "Brakuje klucza podpisu Redsys.",
    },
  },
};
